import EditorImport from 'react-simple-code-editor';

// react-simple-code-editor ships CommonJS with an ESM-flavoured d.ts; under node16 module resolution
// the default import is typed as the module object while Vite actually hands us the component.
// Re-typed once here so CodeEditor and SqlEditor can use it as a JSX element.
export const Editor = EditorImport as unknown as (typeof EditorImport)['default'];
